<template>
	<div>
		<phead></phead>
		<div>
			<div class="banner">
				<a href="https://fee.haopan.net/#/register"><img src="../../assets/img/banner.jpg" width="100%" /></a>
			</div>
			<!--banner end-->
			<div class="content">
				<div class="line-40"></div>
				<div class="main-content">
					<!-- 智能终端 -->
					<div class="title">智 能 终 端</div>
					<div class="line-30"></div>
					<div class="zdBox">
						<div class="zd">
							<div class="mian-zd">
								<div class="zdImg">
									<img src="../../assets/img/zd1.png" />
								</div>
								<div class="txtAction">
									<div class="zdTitle">多登录入口</div>
									<div class="zdCont">登录形式和入口多样化，一键登录，移动审批，实时在线，方便快捷的掌握企业每天经营数据。</div>
								</div>
							</div>
						</div>
						<div class="zd">
							<div class="mian-zd">
								<div class="zdImg">
									<img src="../../assets/img/zd2.png" />
								</div>
								<div class="txtAction">
									<div class="zdTitle">人脸识别</div>
									<div class="zdCont">人脸登录，杜绝冒名顶替，精度高，速度快，确保信息安全，节约时间成本。</div>
								</div>
							</div>
						</div>
						<div class="zd">
							<div class="mian-zd">
								<div class="zdImg">
									<img src="../../assets/img/zd3.png" />
								</div>
								<div class="txtAction">
									<div class="zdTitle">票据识别</div>
									<div class="zdCont">自动识别票据真伪、查重，与财务科目对应，减轻人员工作量的同时，提升工作效率，减少财务人员开支，为企业节省成本。</div>
								</div>
							</div>
						</div>
						<div class="zd">
							<div class="mian-zd">
								<div class="zdImg">
									<img src="../../assets/img/zd4.png" />
								</div>
								<div class="txtAction">
									<div class="zdTitle">硬件增值</div>
									<div class="zdCont">一机多能，用作企业宣传、企业公告、企业通知、企业招聘等之用，集成发布系统，一键操作，支持文字、图片、视频等多种形式为企业经营赋能</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- end -->
				<div class="glpt">
					<div class="glptTitle">管 理 平 台</div>
					<div class="glptCont">
						<div class="glptLeft">
							<p @click="cur=0" :class="{active:cur==0}">制度规范</p>
							<p @click="cur=1" :class="{active:cur==1}">流程配置</p>
							<p @click="cur=2" :class="{active:cur==2}">预算控制</p>
							<p @click="cur=3" :class="{active:cur==3}">移动审批</p>
							<p @click="cur=4" :class="{active:cur==4}">银企直连</p>
							<p @click="cur=5" :class="{active:cur==5}">数据分析</p>
						</div>
						<div class="glptRight">
							<div class="glptText" v-show="cur==0">
								<div class="ptCont">根据企业的经营需要，明细报销名录，报销制度规范化，不超标、不违规，为企业规范化经营提供依据，提高资金使用率。</div>
								<div class="ptImg"><img class="p-img1" src="../../assets/img/zdgf_img.jpg" /></div>
							</div>
							<div class="glptText" v-show="cur==1">
								<div class="ptCont">基于SaaS流程引擎，企业可自定义审批流程。</div>
								<div class="ptImg"><img src="../../assets/img/lcpz_img.jpg" /></div>
							</div>
							<div class="glptText" v-show="cur==2">
								<div class="ptCont">最精细、实用的预算管理模型，帮您的企业控好每一笔支出。</div>
								<div class="ptImg"><img src="../../assets/img/yskz_img.jpg" /></div>
							</div>
							<div class="glptText" v-show="cur==3">
								<div class="ptCont">打破时间和空间的限制，随时查随地批，缩短审批时间。</div>
								<div class="ptImg"><img class="p-img2" src="../../assets/img/ydsp_img.jpg" /></div>
							</div>
							<div class="glptText" v-show="cur==4">
								<div class="ptCont">审批结束直接打款，数据可追溯，减少人为失误风险，让企业资金管控更安全。</div>
								<div class="ptImg"><img src="../../assets/img/qyzl_img.jpg" /></div>
							</div>
							<div class="glptText" v-show="cur==5">
								<div class="ptCont">运用大数据分析等前瞻技术，根据多种分类方式，实时掌握公司预算花费情况，操作简单易懂，为企业领导者决策提供依据。</div>
								<div class="ptImg"><img src="../../assets/img/sjfx_img.jpg" /></div>
							</div>
						</div>
					</div>
				</div>
				<!-- end -->
				<div class="baoZhang">
					<div class="title">连接，让数据行云流水</div>
					<div class="lj-box">
						<img src="../../assets/img/lj_img.png" />
						<i class="con1"></i>
						<i class="con2"></i>
						<i class="con3"></i>
						<i class="con4"></i>
						<i class="con5"></i>
						<i class="con6"></i>
						<i class="con7"></i>
						<i class="con8"></i>
						<i class="con9"></i>
						<i class="con10"></i>
						<div class="item1">
							<p>发票生态</p>
						</div>
						<div class="item2">
							<p>HR系统</p>
						</div>
						<div class="item3">
							<p>
								<span>CRM系统</span>
								<span>ERP系统</span>
							</p>
						</div>
						<div class="item4">
							<p>
								企业协同办公
							</p>
						</div>
						<div class="item5">
							<p>
								<span>资金平台</span>
								<span>银企直连</span>
							</p>
						</div>
						<div class="item6">
							<p>网上银行</p>
						</div>
						<div class="item7">
							<p>蜘蛛金控一体机</p>
						</div>

					</div>
				</div>
				<!-- end -->
				<div>
					<div class="title">全流程费用管理解决方案</div>
					<ul class="fy-box">
						<li class="fy1">
							<img src="../../assets/img/f-1.png" />
							<span class="color-blue">智能终端提交</span>
						</li>
						<li class="fy2">
							<img src="../../assets/img/f-2.png" />
							<span class="color-blue">领导审核</span>
						</li>
						<li class="fy3">
							<img src="../../assets/img/f-3.png" />
							<span>出纳支付</span>
						</li>
						<li class="fy4">
							<img src="../../assets/img/f-4.png" />
							<span>生成统计报表</span>
						</li>
					</ul>
				</div>
				<!-- end -->
				<div class="sjaq">
					<div class="title color-fff">数 据 安 全</div>
					<div class="sjan-mian">
						<div class="txt1">
							<div class="sjaq-tit">隔离企业</div>
							<div class="cows-t">数据企业间业务数据隔离，杜绝数据外泄</div>
						</div>
						<div class="txt2">
							<div class="sjaq-tit">细分数据</div>
							<div class="cows-t">数据权限按角色多级细分，满足内控要求</div>
						</div>
						<div class="txt3">
							<div class="sjaq-tit">备份恢复</div>
							<div class="cows-t">系统故障快速恢复，确保数据不丢失</div>
						</div>
						<div class="txt4">
							<div class="sjaq-tit">数据存储</div>
							<div class="cows-t">关键数据采用独立、第三方进行加密以及密钥分离托管</div>
						</div>
						<div class="txt5">
							<div class="sjaq-tit">阿里云安全</div>
							<div class="cows-t">基于阿里云架构，由阿里云保障系统及网络安全</div>
						</div>
						<div class="txt6">
							<div class="sjaq-tit">网络传输</div>
							<div class="cows-t">多端信息内容，传输通道HTTPS高强度加密</div>
						</div>
					</div>
				</div>
				<!-- end -->
				<div class="lianJie">
					<div class="main-lianJie">
						<div class="ljTitle">多系统无缝对接</div>
						<div class="lianJieCont">
							<div class="ljBox">
								<div class="ljImg"><img src="../../assets/img/lj1.png" /></div>
								<div class="ljText">协同办公</div>
							</div>
							<div class="ljBox">
								<div class="ljImg"><img src="../../assets/img/lj2.png" /></div>
								<div class="ljText">CRM系统</div>
							</div>
							<div class="ljBox">
								<div class="ljImg"><img src="../../assets/img/lj3.png" /></div>
								<div class="ljText">财务系统</div>
							</div>
							<div class="ljBox">
								<div class="ljImg"><img src="../../assets/img/lj4.png" /></div>
								<div class="ljText">网上银行</div>
							</div>
						</div>
					</div>
				</div>
				<!-- end -->
			</div>
			<!--content end-->
		</div>
		<!-- 悬浮窗 -->
		<div class="fixedonline">
			<ul>
				<li>
					<a href="javascript:void(0);">
						<img src="../../assets/img/phone_icon.png" />
						<p>联系电话</p>
					</a>
					<ul class="li_ul">
						<li>025-51860071</li>
					</ul>
				</li>
				<li>
					<a href="tencent://message/?uin=2166519809&Site=&Menu=yes">
						<img src="../../assets/img/qq_icon.png" />
						<p>在线客服</p>
					</a>
				</li>
			</ul>
		</div>

		<pfoot></pfoot>
	</div>
</template>

<script>
	import phead from "../common/phead";
	import pfoot from "../common/pfoot";
	import {
		AxiosPost
	} from "../../api/common/common";

	export default {
		name: "Index",
		data() {
			return {
				cur: 0
			};
		},
		methods: {

		},
		components: {
			phead: phead,
			pfoot: pfoot
		}
	};
</script>

<style scoped>
	@import "../../assets/css/index.css";
	@import "../../assets/css/action.min.css";
</style>



// WEBPACK FOOTER //
// src/components/index/index.vue